import { mediaUrls } from 'globalconfig/constants/mediaUrls';

// Group constants into categories
const Events = {
  Accident: {
    DRIVING_HIT: 'Driving Accident',
    PARKING_HIT: 'Parked - Accident',
    PARKING_MOTION: 'Parked - Motion Sensor',
    DRIVING_HEAVY_HIT: 'Driving Hard Accident',
    PARKING_HEAVY_HIT: 'Parked - Hard Accident',
    POTENTIAL_INCIDENT_LOW: 'Accident - Probability Low',
    POTENTIAL_INCIDENT_HIGH: 'Accident - Probability High',
    FORWARD_COLLISION_WARNING: 'Forward Collision Warning',
    POTENTIAL_INCIDENT_MEDIUM: 'Accident - Probability Medium',
  },
  DrivingBehavior: {
    HARD_BRAKE: 'Hard Brake',
    HARSH_TURN: 'Harsh Turn',
    SHARP_TURN: 'Sharp Turn',
    HARSH_BRAKE: 'Harsh Brake',
    SEVERE_TURN: 'Severe Turn',
    SEVERE_BRAKE: 'Severe Brake',
    HARD_ACCEL: 'Hard Acceleration',
    HARSH_ACCEL: 'Harsh Acceleration',
    SEVERE_ACCEL: 'Severe Acceleration',
  },
  DistractedDriving: {
    YAWN: 'Yawn',
    ASLEEP: 'Asleep',
    SMOKING: 'Smoking',
    POWER_LOST: 'No Power',
    DAYDREAMING: 'Daydream',
    USING_PHONE: 'Phone Use',
    DISTRACTED: 'Distracted',
    DROWSINESS: 'Drowsiness',
    NO_SEATBELT: 'No Seat Belt',
    MANUAL: 'Manual Event Created',
    IDLE_NO_DRIVER: 'Vehicle On - Driver Away',
    STOP_SIGN_VIOLATION: 'Stop Sign Violation',
    HEADWAY_MONITORING_WARNING: 'Tailgating - Close',
    LANE_DEPARTURE_WARNING: 'Lane Departure Warning',
    HEADWAY_MONITORING_EMERGENCY: 'Tailgating - Dangerous',
  },
};

// Group event categories into arrays
const EventCategories = {
  accidentEvents: [
    Events.Accident.PARKING_HIT,
    Events.Accident.PARKING_HEAVY_HIT,
    Events.Accident.DRIVING_HIT,
    Events.Accident.DRIVING_HEAVY_HIT,
    Events.Accident.POTENTIAL_INCIDENT_LOW,
    Events.Accident.POTENTIAL_INCIDENT_MEDIUM,
    Events.Accident.POTENTIAL_INCIDENT_HIGH,
    Events.Accident.FORWARD_COLLISION_WARNING,
  ],
  speedingEvents: [
    ...Object.values(Events.DrivingBehavior),
    Events.Accident.PARKING_HEAVY_HIT,
    Events.Accident.FORWARD_COLLISION_WARNING,
  ],
  distractedEvents: [
    Events.DrivingBehavior.SHARP_TURN,
    Events.DrivingBehavior.HARSH_BRAKE,
    Events.DrivingBehavior.HARSH_TURN,
    Events.DrivingBehavior.SEVERE_ACCEL,
    Events.DrivingBehavior.SEVERE_BRAKE,
    Events.DrivingBehavior.SEVERE_TURN,
    Events.DistractedDriving.ASLEEP,
    Events.DistractedDriving.DROWSINESS,
    Events.DistractedDriving.YAWN,
    Events.DistractedDriving.DAYDREAMING,
    Events.DistractedDriving.USING_PHONE,
    Events.DistractedDriving.DISTRACTED,
    Events.DistractedDriving.SMOKING,
    Events.DistractedDriving.NO_SEATBELT,
    Events.DistractedDriving.IDLE_NO_DRIVER,
    Events.DistractedDriving.LANE_DEPARTURE_WARNING,
    Events.DistractedDriving.STOP_SIGN_VIOLATION,
    Events.DistractedDriving.POWER_LOST,
    Events.Accident.FORWARD_COLLISION_WARNING,
  ],
};

const fleetIconMapping = {
  Van: mediaUrls.van,
  Dump: mediaUrls.dump,
  Pickup: mediaUrls.pickup,
  Flatbed: mediaUrls.flatBed,
  Bobtail: mediaUrls.bobTail,
  'Dry Van': mediaUrls.dryVan,
  Reefer: mediaUrls.reeferTrailer,
  'Box Truck': mediaUrls.boxTruck,
  Vacuum: mediaUrls.vacuumTrailer,
  Tanker: mediaUrls.tankerTrailer,
  Other: mediaUrls.otherTrailer,
  infoTruck: mediaUrls.infoTruck,
  Pneumatic: mediaUrls.pneumaticTrailer,
  'Other Trailers': mediaUrls.otherTrailer,
  'Other Vehicles': 'otherVehicle',
  'Straight Truck': mediaUrls.straightTruck,
  'Tractor Day Cab': mediaUrls.tractorDayCab,
  'Tractor Sleeper': mediaUrls.tractorSleeper,
  'Private Passenger': mediaUrls.privatePassenger,
};

export { Events, EventCategories, fleetIconMapping };
